import { http } from '../../config/axios'

export default function putSaldoClienteCompraPagamentoService(franquia: any): Promise<string> {
  return http
    .put('api/cliente-saldo-compra/pagamento-manual', franquia)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro put saldo cliente compra pagamento', error)
      throw Error(error.response.data)
    })
}
